import * as Yup from 'yup';

export const NO_LEADING_TRAILING_SPACES_VALIDATION = Yup.string().test(
  'no-leading-trailing-spaces',
  'Поле не должно начинаться или заканчиваться пробелами',
  (value) => value?.trim() === value,
);

export const INTEGER_VALIDATION = Yup.string()
  .test('is-number', 'Должно быть числом', (value) => !value || !isNaN(Number(value)))
  .test('is-min', 'Должно быть не меньше 0', (value) => !value || Number(value) >= 0)
  .test(
    'no-leading-zeros',
    'Недопустимо вводить ведущие нули',
    (value) => !value || value === '0' || !/^0\d+/.test(value),
  )
  .test(
    'no-leading-trailing-spaces',
    'Поле не должно начинаться или заканчиваться пробелами',
    (value) => value?.trim() === value,
  )
  .test('is-integer-number', 'Укажите целое число', (value) =>
    value !== undefined && value !== '' ? Number.isInteger(Number(value)) && !value?.includes('.') : true,
  );
